import { reactive } from "vue";
import { ToastType } from "@/types/toast";
import { ToastColors } from "@/constants/toastColors";
import { ToastIcons } from "@/constants/toastIcons";

export default class Toast {
  private state = reactive({
    visible: false,
    message: "",
    icon: "",
    color: "",
  });

  showToast(message: string, type: ToastType = ToastType.Success) {
    this.state.message = message;
    this.state.color = ToastColors[type];
    this.state.icon = ToastIcons[type];
    this.state.visible = true;
  }

  getState() {
    return this.state;
  }
}
